(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-product"]) return;
  try {
    
function initBfColourGallery(root){
  root.querySelectorAll('[data-bf-product]').forEach(section=>{
    if(section.dataset.galleryReady)return;
    section.dataset.galleryReady='true';
    const photo=section.querySelector('.bf-selected-photo');
    const select=section.querySelector('select[name="id"]');
    const thumbs=[...section.querySelectorAll('.bf-photo-thumb')];
    function showImage(url,alt,id){
      if(!photo||!url)return;
      photo.removeAttribute('srcset');
      photo.src=url;
      photo.alt=alt;
      thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t.dataset.imageId===id)));
    }
    function selectColour(){
      const option=select?.selectedOptions[0];
      if(!option)return;
      showImage(option.dataset.imageUrl,option.dataset.imageAlt,option.dataset.imageId);
      section.querySelector('[data-variant-price]').textContent=option.dataset.price;
      section.querySelector('[data-add-button]').disabled=option.disabled;
      const url=new URL(window.location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
    }
    select?.addEventListener('change',selectColour);
    thumbs.forEach(t=>t.addEventListener('click',()=>{
      const match=select&&[...select.options].find(o=>o.dataset.imageId===t.dataset.imageId);
      if(match&&!match.disabled){select.value=match.value;selectColour();}
      else showImage(t.dataset.imageUrl,t.dataset.imageAlt,t.dataset.imageId);
    }));
  });
}
initBfColourGallery(document);
document.addEventListener('shopify:section:load',event=>initBfColourGallery(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
